export function PreviewHistoryCopyLink(props: {}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.2298 4.10999L11.1698 3.17001C11.5416 2.79868 11.9828 2.50422 12.4684 2.30347C12.954 2.10272 13.4744 1.99959 13.9998 2C14.7853 2.0052 15.5518 2.24154 16.2038 2.67954C16.8558 3.11754 17.3645 3.7378 17.6663 4.46298C17.9681 5.18816 18.0497 5.98616 17.9009 6.75742C17.7522 7.52868 17.3797 8.23907 16.8298 8.79999L13.8298 11.8C13.3979 12.2326 12.8726 12.5606 12.2943 12.7585C11.7159 12.9565 11.0998 13.0193 10.4934 12.942C9.88695 12.8648 9.30629 12.6496 8.79602 12.3129C8.28575 11.9763 7.85942 11.5271 7.5498 11"
        stroke="#12192B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.76978 15.89L8.82977 16.83C8.07921 17.5806 7.06124 18.0022 5.99979 18.0022C4.93833 18.0022 3.92036 17.5806 3.1698 16.83C2.41924 16.0794 1.99756 15.0615 1.99756 14C1.99756 12.9385 2.41924 11.9206 3.1698 11.17L6.1698 8.17001C6.54155 7.79868 6.9828 7.50422 7.46838 7.30347C7.95396 7.10272 8.47434 6.99959 8.99979 7C9.69662 6.99941 10.3815 7.18086 10.9867 7.5264C11.5918 7.87194 12.0962 8.36957 12.4498 8.97"
        stroke="#12192B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
